import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {StaticQuery, graphql} from 'gatsby';
import posed, {Transition} from 'react-pose';

import Header from './Header';

import './layout.css';

import styles from './layout.module.css';
import currentlyowned from '../images/currentlyowned.jpg';

const Route = posed.div();

const Layout = ({children, location}) => ( // eslint-disable-line
    <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
                metaTitle
                description
                keywords
              }
            }
          }
        `}
        render={(data) => (
            <>
                <Helmet
                    title={data.site.siteMetadata.title}
                    meta={[
                        {
                            property: 'og:image',
                            content: currentlyowned,
                        },
                        {
                            property: 'og:title',
                            content: data.site.siteMetadata.metaTitle,
                        },
                        {
                            name: 'description',
                            content: data.site.siteMetadata.description,
                        },
                        {
                            property: 'og:description',
                            content: data.site.siteMetadata.description,
                        },
                        {
                            name: 'keywords',
                            content: data.site.siteMetadata.keywords,
                        },
                    ]}
                >
                    <html lang="en" />
                    <link rel="stylesheet" href="https://use.typekit.net/nmv6fhk.css" />
                </Helmet>
                <Header />
                <div className={styles.container}>
                    <Transition preEnterPose="preEnter">
                        <Route key={location.pathname}>
                            {children}
                        </Route>
                    </Transition>
                </div>
            </>
        )}
    />
);

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
